import {
  DateRange,
  GoalProgressDateRangePreset,
  Timestamp,
  WeekDays,
} from '@griply/types';
import {
  endOfMonth,
  endOfQuarter,
  endOfWeek,
  endOfYear,
  startOfMonth,
  startOfQuarter,
  startOfWeek,
  startOfYear,
} from 'date-fns';

import { weekdaysNumberMap } from './constants';

export type GetGoalProgressDateRangeOptions = {
  goalRange: DateRange;
  today: Timestamp;
  weekStartsOn: WeekDays;
};

export const getGoalProgressDateRange = (
  preset: GoalProgressDateRangePreset,
  { goalRange, today, weekStartsOn }: GetGoalProgressDateRangeOptions,
): DateRange => {
  if (preset === GoalProgressDateRangePreset.Week) {
    const weekOptions = { weekStartsOn: weekdaysNumberMap[weekStartsOn] };
    return {
      startDate: startOfWeek(today, weekOptions),
      endDate: endOfWeek(today, weekOptions),
    };
  }

  if (preset === GoalProgressDateRangePreset.Month) {
    return {
      startDate: startOfMonth(today),
      endDate: endOfMonth(today),
    };
  }

  if (preset === GoalProgressDateRangePreset.Quarter) {
    return {
      startDate: startOfQuarter(today),
      endDate: endOfQuarter(today),
    };
  }

  if (preset === GoalProgressDateRangePreset.Year) {
    return {
      startDate: startOfYear(today),
      endDate: endOfYear(today),
    };
  }

  return goalRange;
};
